import { Project } from '../../../../@types/projects/types';
import {
  DEFAULT_RESULTS_CURVE_POINTS,
  buildLiaoZoneCurves,
  clampCurvePointCount
} from '../../../utils/curveGeneration';

export class LiaoSystemSaturationCalculationStrategy {
  public calculate(project: Project, numberOfPoints: number = DEFAULT_RESULTS_CURVE_POINTS): Project {
    const zones = project.correlation?.zones;
    const gradDiff = project.correlation?.grad_diff;
    if (!zones?.length || typeof gradDiff !== 'number') {
      return project;
    }

    const pointCount = clampCurvePointCount(numberOfPoints);
    zones.forEach(zone => {
      (['fzi', 'rqi'] as const).forEach(xAxis => {
        const axisZoneValues = zone.zone_values_by_x_axis?.[xAxis] ?? (xAxis === 'fzi' ? zone.zone_values : null);
        if (!axisZoneValues) return;
        const curves = buildLiaoZoneCurves({ ...zone, zone_values: axisZoneValues }, gradDiff, pointCount);
        if (!curves) return;
        zone.zone_curves_by_x_axis = {
          ...(zone.zone_curves_by_x_axis ?? {}),
          [xAxis]: {
            liao_curves: curves,
            lambda_curves: zone.zone_curves_by_x_axis?.[xAxis]?.lambda_curves ?? null
          }
        };
        if (xAxis === 'fzi') {
          zone.zone_curves = {
            liao_curves: curves,
            lambda_curves: zone.zone_curves?.lambda_curves ?? null
          };
        }
      });
    });

    return project;
  }
}

const calculator = new LiaoSystemSaturationCalculationStrategy();

globalThis.onmessage = (event: MessageEvent<{ project: Project; numberOfPoints?: number }>) => {
  try {
    const resultProject = calculator.calculate(
      event.data.project,
      event.data.numberOfPoints ?? DEFAULT_RESULTS_CURVE_POINTS
    );
    globalThis.postMessage({ status: 'success', data: resultProject });
  } catch (error: any) {
    globalThis.postMessage({ status: 'error', message: error.message });
  }
};
